<script lang="ts" setup>
/**
 * A reusable close button for GSheet components.
 * Renders as a circular button with an X icon.
 */
import { faXmark } from '@fortawesome/pro-regular-svg-icons'

defineProps<{
  disabled?: boolean
}>()

defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<template>
  <GSheetButton
    :disabled="disabled"
    class="g-sheet-button-close"
    :icon="faXmark"
    @click="$emit('click', $event)"
  />
</template>
